.productToggle {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.75rem;
	padding: 0.75rem 1rem;
	background-color: #ffffff;
	border: 1px solid #e5e7eb;
	border-radius: 0.5rem;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
	min-height: 60px;
	max-width: 40%;
	font-size: 14px;
	margin-bottom: 10px;

	:global(.dark) & {
		background-color: #1f2937;
		border-color: #374151;
	}

	@media (min-width: 640px) {
		flex-direction: row;
	}
}

.productToggleInfo {
	display: flex;
	flex-direction: column;
	gap: 0.125rem;
	line-height: 1.2;
}

.productToggleTitle {
	font-size: 0.85rem;
	font-weight: 500;
	color: #1f2937;

	:global(.dark) & {
		color: #f9fafb;
	}
}

.productToggleSubtitle {
	font-size: 0.75rem;
	color: #6b7280;

	:global(.dark) & {
		color: #9ca3af;
	}
}

.loader {
	font-style: italic;
	color: #9ca3af;

	:global(.dark) & {
		color: #d1d5db;
	}
}

.spinner {
	width: 14px;
	height: 14px;
	border: 2px solid #cbd5e1;
	border-top: 2px solid #81ba43;
	border-radius: 50%;
	animation: spin 0.6s linear infinite;
	display: inline-block;

	:global(.dark) & {
		border: 2px solid #374151;
		border-top: 2px solid #38bdf8;
	}

	margin-right: 6px;
	vertical-align: middle;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
